import React, { useState } from 'react';
import Accordion from '../../../../Accordion';
import { Database, Calculator, Info, BarChart3 } from 'lucide-react';

const ExistingStockDocumentationAccordion = () => {

  const [activeKey, setActiveKey] = useState(null);

  return (
    <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 md:px-6 lg:px-8 py-4 md:py-5 border-b border-gray-200">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Info className="h-5 w-5 text-blue-600" />
          </div>
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-gray-900">Data Sources & Methodology</h3>
            <p className="text-sm md:text-base text-gray-600 mt-0.5">Current power plant fleet composition by age and size</p>
          </div>
        </div>
      </div>

      <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)} className="border-0">
        <Accordion.Item eventKey="0" className="border-0 border-b border-gray-100">
          <Accordion.Header className="px-4 md:px-6 lg:px-8 py-4 md:py-5 hover:bg-gray-50 transition-colors">
            <div className="flex items-center gap-3 w-full">
              <div className="p-2 bg-orange-100 rounded-lg">
                <BarChart3 className="h-4 w-4 text-orange-600" />
              </div>
              <div className="text-left">
                <h4 className="text-sm md:text-base lg:text-lg font-semibold text-gray-900 mb-0">Age Distribution by Fuel Type</h4>
                <p className="text-xs md:text-sm text-gray-500 mt-0.5 mb-0">Distribution of power plants by age and fuel type</p>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body className="px-4 md:px-6 lg:px-8 pb-4 md:pb-5">
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <Database className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Data Source</p>
                  <p className="text-xs lg:text-sm text-gray-700">GEM (Global Energy Monitor)</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Calculator className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Processing</p>
                  <p className="text-xs lg:text-sm text-gray-700">
                    Filtered to operating plants only. Age calculated as (Current Year - Commissioning Year). Fuel types
                    standardized. Unit-level data aggregated by plant.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Info className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Note</p>
                  <p className="text-xs lg:text-sm text-gray-700">
                    GEM is an open-source, community-verified global power plant database. Coverage focuses on large-scale
                    plants; small distributed generation (rooftop solar, small hydro) may not be fully captured. Coverage
                    completeness varies by country depending on official data availability.
                  </p>
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1" className="border-0">
          <Accordion.Header className="px-4 md:px-6 lg:px-8 py-4 md:py-5 hover:bg-gray-50 transition-colors">
            <div className="flex items-center gap-3 w-full">
              <div className="p-2 bg-purple-100 rounded-lg">
                <BarChart3 className="h-4 w-4 text-purple-600" />
              </div>
              <div className="text-left">
                <h4 className="text-sm md:text-base lg:text-lg font-semibold text-gray-900 mb-0">Size Distribution by Fuel Type</h4>
                <p className="text-xs md:text-sm text-gray-500 mt-0.5 mb-0">Distribution of power plants by capacity and fuel type</p>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body className="px-4 md:px-6 lg:px-8 pb-4 md:pb-5">
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <Database className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Data Source</p>
                  <p className="text-xs lg:text-sm text-gray-700">GEM (Global Energy Monitor)</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Calculator className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Processing</p>
                  <p className="text-xs lg:text-sm text-gray-700">
                    Filtered to operating plants only. Capacity binned into size categories. Fuel types standardized.
                    Unit-level data aggregated by plant.
                  </p>
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default ExistingStockDocumentationAccordion;
